import React from "react";
import TablaProductoCodificado from "js/components/TablaProductoCodificado";

function ProductoCodificado(props) {
  return <TablaProductoCodificado />;
}

export default ProductoCodificado;
